import {
  type DefaultError, type MutationFunction,
  type MutationOptions, type QueryKey,
  useMutation,
  useQueryClient
} from '@tanstack/vue-query'

export function useMutationWithInvalidation<TData, TVariables>(options: MutationFunction<TData, TVariables>|MutationOptions<TData, DefaultError, TVariables>, keys: (QueryKey|((input: TVariables) => QueryKey|undefined))[]) {
  const client = useQueryClient()
  const optionsObject: MutationOptions<TData, DefaultError, TVariables> = typeof options === 'function'
    ? { mutationFn: options }
    : { ...options }

  return useMutation({
    ...optionsObject,
    async onSuccess(output, input, context) {
      await Promise.all(
        keys.map(
          queryKey => {
            if (Array.isArray(queryKey)) {
              return client.invalidateQueries({ queryKey })
            }

            if (typeof queryKey === 'function') {
              const resolvedKey = queryKey(input)

              if (resolvedKey !== undefined) {
                return client.invalidateQueries({ queryKey: resolvedKey })
              }
            }

            return Promise.resolve()
          }
        )
      )

      return optionsObject.onSuccess?.(output, input, context)
    }
  })
}
